<template>
  <div class="view-tasklists assessment-add-section">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu />
        <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Edit Introduction</h3>
          </div>
          <div style="clear: both"></div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>
          <div>
            <div class="float-left col-md-10 col-12 p-0" style="padding-left: 0;padding-top: 5px;">
              <div class="text-align-center">{{ introduction_title }} <i class="fa fa-pencil-square-o" aria-hidden="true" @click="editIntroductionModalAction()" style="cursor: pointer;"></i></div>
            </div>
            <div class="col-lg-2 padding-lr-5 float-right text-align-right" style="padding-right: 0;">
              <button
                v-on:click="addSlideClick()"
                class="btn btn-red btn-md input-height-15 float-right text-align-right" style="height: 30px;"
                ><i class="fa fa-plus spacer-icon" aria-hidden="true"></i> Slide</button>
            </div>

          </div>
          <div style="clear: both"></div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
          <div class="task-list-summary float-left col-10 override-padding" style="padding-top: 1px;">
            <span>Introduction Summary: {{ introduction_slide_obj.slide.length }} Slides</span> 
          </div>
          <div
            v-if="this.introduction_slide_obj.slide.length > 0"
            class="submit float-right col-2 override-padding" @click="onSubmit">
            <button type="submit" class="col-12 btn btn-red btn-md col-12 input-height-15">Save Introduction</button>
          </div>
          </div>

          <div style="clear: both"></div>
          <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>


          <div class="section-display" v-if="introduction_slide_obj.slide.length > 0">
            <ul v-sortable="{onEnd: reorderSection, handle: '.handle1'}" class="counter_section-list list-group col-lg-12  override-padding margin-bottom-10">
              <li class="list-group-item input-height-25" v-for="(slide, sindex) in introduction_slide_obj.slide" :key="slide.sortid" style="margin-top: 10px;">
                <div class="section_item float-left col-12 override-padding" >
                  <div class="col-12 override-padding float-left">
                    <div class="handle1 float-left col-lg-12 override-padding" style="padding-top: 2px;">
                      <div class="col-10 override-padding float-left">
                      <i class="fa fa-arrows padding-right-5" aria-hidden="true"></i>
                      <span style="font-weight: bold">
                      <span class="counter_section-list__counter"></span>
                      </span>
                      {{ slide.title }} &nbsp; <i class="fa fa-pencil-square-o" aria-hidden="true" @click="editSlideAction(sindex)" style="cursor: pointer;"></i>
                      </div>

                      <div class="col-lg-2 padding-lr-5 float-right text-align-right" style="padding-right: 0;">
                        <button
                          v-on:click="addItemClick(sindex)"
                          class="btn btn-red btn-md input-height-15  text-align-right" style="height: 30px;"
                          ><i class="fa fa-plus spacer-icon" aria-hidden="true"></i> Item</button>
                          <i class="cursor-pointer fa fa-times"  style="padding-left: 10px;" aria-hidden="true" @click="deleteSlideConfirm(sindex)"></i>
                      </div>

                      <div style="clear: both"></div>

                      <div
                        class="heading_container"
                        :class="slide.item.length > 0 ? 'margin-bottom-5' : ''"
                        >


                        <div class="heading_list">
                          <ul
                            
                            class="counter_heading-list list-group col-lg-12 override-padding" :data-id="sindex">
                            <li class="list-group-item input-height-25" v-for="(item, iindex) in slide.item" :key="iindex" style="border: 0;">
                              <div class="heading_item">
                                <div class="handle2 float-left  override-padding" style="width: 82.66%; padding-top: 2px; border: 0;" v-if="item.type == 'Link'">
                                  {{ item.type }} - {{ item.image_link }} 
                                  &nbsp;-&nbsp;
                                  <div style="display: inline; text-decoration: underline; cursor: pointer; color: #00ACEE;" @click="editAction(sindex, iindex)">Edit</div>
                                  &nbsp;-&nbsp;
                                  <div style="display: inline; text-decoration: underline; cursor: pointer; color: #00ACEE;" @click="viewAction(sindex, iindex)">View</div>
                                </div>
                                <div class="handle2 float-left  override-padding" style="width: 82.66%; padding-top: 2px; border: 0;" v-else-if="item.type == 'Button'">
                                  {{ item.type }} - {{ item.image_link }} 
                                  &nbsp;-&nbsp;
                                  <div style="display: inline; text-decoration: underline; cursor: pointer; color: #00ACEE;" @click="editAction(sindex, iindex)">Edit</div>
                                  &nbsp;-&nbsp;
                                  <div style="display: inline; text-decoration: underline; cursor: pointer; color: #00ACEE;" @click="viewAction(sindex, iindex)">View</div>
                                </div>
                                <div v-else-if="item.type == 'Image'" class="handle2 float-left  override-padding" style="width: 82.66%; padding-top: 2px; border: 0;">
                                  {{ item.type }} - {{ item.image_link }}
                                  &nbsp;-&nbsp;
                                  <div style="display: inline; text-decoration: underline; cursor: pointer; color: #00ACEE;" @click="editAction(sindex, iindex)">Edit</div>
                                  &nbsp;-&nbsp;
                                  <div style="display: inline; text-decoration: underline; cursor: pointer; color: #00ACEE;" @click="viewAction(sindex, iindex)">View</div>
                                </div>
                                <div v-else-if="(item.type == 'Assessment' || item.type == 'Course')" class="handle2 float-left  override-padding" style="width: 82.66%; padding-top: 2px; border: 0;">
                                  {{ item.type }} - {{ item.text }} 
                                  &nbsp;-&nbsp;
                                  <div style="display: inline; text-decoration: underline; cursor: pointer; color: #00ACEE;" @click="editAction(sindex, iindex)">Edit</div>
                                  &nbsp;-&nbsp;
                                  <div style="display: inline; text-decoration: underline; cursor: pointer; color: #00ACEE;" @click="viewAction(sindex, iindex)">View</div>
                                </div>
                                <div v-else class="handle2 float-left  override-padding" style="width: 82.66%; padding-top: 2px; border: 0;">
                                  {{ item.type }} - {{ item.text | stripHTML }} 
                                  &nbsp;-&nbsp;
                                  <div style="display: inline; text-decoration: underline; cursor: pointer; color: #00ACEE;" @click="editAction(sindex, iindex)">Edit</div>
                                  &nbsp;-&nbsp;
                                  <div style="display: inline; text-decoration: underline; cursor: pointer; color: #00ACEE;" @click="viewAction(sindex, iindex)">View</div>
                                </div>
                                <div class="col-lg-2 padding-lr-5 float-right text-align-right" style="padding-right: 0;">
                                    <i class="cursor-pointer fa fa-times"  style="padding-left: 10px;" aria-hidden="true"  @click="deleteItemConfirm(sindex, iindex)"></i>
                                </div>

                              </div>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

          </div>








        </div>
        </div>
    </div>





    <createSlideModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>New Slide</h3></div>
      <div slot="body" v-if="isModalVisible == true">

        <div class="col-12 override-padding">
          <input v-model="slide_title"
                name="slide_title"
                placeholder="Enter Slide Title..."
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'"
                maxlength="255" />
         <div v-if="verrors.firstByRule('slide_title', 'required')" class="margin-bottom-5 validate-warning-msg">Slide Title is required</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <div class="col-12 override-padding">
             <b-form-select
              class="input-text"
              name="slide_template"
              v-model="slide_template"
              :options="template_options"
            >
            </b-form-select>
         <div v-if="verrors.firstByRule('slide_template', 'required')" class="margin-bottom-5 validate-warning-msg">Slide Template is required</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <input
            type="checkbox"
            v-bind:id="show_skip_button"
            v-bind:name="show_skip_button"
            ref="show_skip_button"
            v-model="show_skip_button_selected"
            :checked="show_skip_button_checked"
            :value="1" style="margin-top: 4px;">
          <label class="" for="submit_comment_1" style="color: #002F42;">Show Skip Button</label>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div class="col-12 override-padding text-center">
          <button
              v-on:click="createSlide()"
              class="btn btn-red btn-md input-height-15 col-2"
              style="height: 30px;"
              ><b><i class="fa fa-plus spacer-icon" aria-hidden="true"></i> Slide</b></button>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </createSlideModal>



    <createItemModal :isModalVisible="isItemModalVisible" @close="isItemModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Introduction Item</h3></div>
      <div slot="body"  v-if="isItemModalVisible == true">

        <div class="col-12 override-padding">
           <b-form-select
            class="input-text"
            v-model="item_type"
            :options="item_options"
            @change="verrors.clear(), verrors.items = []"
          >
          </b-form-select>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div v-if="item_type == 'Text'" class="col-12 override-padding assessment-intro1">
          <vue-editor v-model="item_text" name="item_text" :editorToolbar="customToolbar" ref="textarea" placeholder="Enter Text" @text-change="introTextChange"></vue-editor>
          <div v-if="verrors.firstByRule('item_text', 'required')" class="margin-bottom-5 validate-warning-msg">Text is required</div>
          <div style="clear: both;margin-bottom: 50px;"></div>
        </div>
        <div v-else-if="item_type == 'Image'" class="col-12 override-padding">
          <input 
            @change="handleImage"
            type="file" 
            name="image_file"
            ref="image_file"
            v-validate="'required'"
            accept="image/*"
            rules="required"
            class="input-file">
          <div v-if="verrors.firstByRule('image_file', 'required')" class="margin-bottom-5 validate-warning-msg">Image is required</div>
          <div class="help-text">Image should be jpg, jpeg, gif, png and size should be of 2MB</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <input v-model="image_link"
                name="image_link"
                placeholder="Enter Link"
                class="col-lg-12 input-text form-control"
                style="line-height: 30px " 
                v-validate="'required'"
                maxlength="255" />
          <div v-if="verrors.firstByRule('image_link', 'required')" class="margin-bottom-5 validate-warning-msg">Link is required</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
        </div>
        <div v-else-if="item_type == 'Link'" class="col-12 override-padding">
          <input v-model="item_link"
                name="item_link"
                placeholder="Enter Link"
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'" 
                maxlength="255" />
          <div v-if="verrors.firstByRule('item_link', 'required')" class="margin-bottom-5 validate-warning-msg">Link is required</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <input v-model="item_link_text"
                name="item_link_text"
                placeholder="Link Text"
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'"
                maxlength="255" />
          <div v-if="verrors.firstByRule('item_link_text', 'required')" class="margin-bottom-5 validate-warning-msg">Text is required</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
        </div>
        <div v-else-if="item_type == 'Button'" class="col-12 override-padding">
          <input v-model="item_button_text"
                name="item_button_text"
                placeholder="Button Text"
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'"
                maxlength="255" />
          <div v-if="verrors.firstByRule('item_button_text', 'required')" class="margin-bottom-5 validate-warning-msg">Button Text is required</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <input v-model="item_button_link"
                name="item_button_link"
                placeholder="Enter Link"
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'" 
                maxlength="255" />
          <div v-if="verrors.firstByRule('item_button_link', 'required')" class="margin-bottom-5 validate-warning-msg">Link is required</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
        </div>

        <div v-else-if="item_type == 'Assessment'" class="col-12 override-padding">
           <b-form-select
            class="input-text"
            name="assessment_selected"
            v-model="assessment_selected"
            :options="assessment_options" 
            v-validate="'required'"
            v-on:change="onChangeAssessmentType"
          >
          </b-form-select>
          <div v-if="verrors.firstByRule('assessment_selected', 'required')" class="margin-bottom-5 validate-warning-msg">Assessment is required</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
        </div>
        <div v-else-if="item_type == 'Course'" class="col-12 override-padding">
           <b-form-select
            class="input-text"
            name="course_selected"
            v-model="course_selected"
            :options="course_options" 
            v-validate="'required'"
            v-on:change="onChangeCourseType"
          >
          </b-form-select>
          <div v-if="verrors.firstByRule('course_selected', 'required')" class="margin-bottom-5 validate-warning-msg">Course is required</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
        </div>
        <div style="clear: both;"></div>
        <div class="col-12 override-padding text-center">
          <button
              v-on:click="AddItem()"
              class="btn btn-red btn-md input-height-15 col-2"
              style="height: 30px;"
              ><b><i class="fa fa-plus spacer-icon" aria-hidden="true"></i> Item</b></button>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </createItemModal>

    <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id" :parent_id="parent_id" @close="isDeleteModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">{{ deleteMessage }}</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-red" @click="isDeleteModalVisible = false; deleteAction()">Confirm</button>
      </div>
    </DeleteModal>


    <editItemModal :isModalVisible="isEditItemModalVisible" @close="isEditItemModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Edit Introduction Item</h3></div>
      <div slot="body" v-if="isEditItemModalVisible == true">

        <div class="col-12 override-padding">
           <b-form-select
            class="input-text"
            v-model="edit_item_type"
            :options="item_options"
            disabled="true"            
          >
          </b-form-select>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <div v-if="edit_item_type == 'Text'" class="col-12 override-padding assessment-intro">
          <vue-editor v-model="edit_item_text" name="edit_item_text" :editorToolbar="customToolbar" ref="textarea" placeholder="Enter Text" @text-change="introTextChange"></vue-editor>
          <div v-if="verrors.firstByRule('edit_item_text', 'required')" class="margin-bottom-5 validate-warning-msg">Text is required</div>
          <div style="clear: both; margin-bottom: 50px;" ></div>
        </div>
        
        <div v-if="edit_item_type == 'Image'" class="col-12 override-padding">
          <div v-if="edit_image_file == ''">
          <input 
            @change="handleEditImage"
            type="file" 
            name="edit_image_file"
            ref="edit_image_file"
            v-validate="'required'"
            accept="image/*"
            rules="required"
            class="input-file">
          <div class="help-text">Image should be jpg, jpeg, gif, png and size should be of 2MB</div>
          <div v-if="verrors.firstByRule('edit_image_file', 'required')" class="margin-bottom-5 validate-warning-msg">Image is required</div>
          </div>
          <div v-else>
            <div class="col-12 p-0">
              <div class="col-3 p-0 float-left">
                <img :src="edit_image_file" width="100" height="100" />
              </div>
              <div class="col-6 p-0 float-left" style="margin-top: 35px">
              <button
                v-on:click="RemoveImage()"
                class="btn btn-red btn-md input-height-15 col-4"
                style="height: 30px;"
                ><b>Remove</b></button>
              </div>
              <div style="clear: both;"></div>    
            </div>
            
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <input v-model="edit_image_link"
                name="edit_image_link"
                placeholder="Enter Link..."
                class="col-lg-12 input-text form-control"
                style="line-height: 30px " 
                v-validate="'required'"
                maxlength="255" />
          <div v-if="verrors.firstByRule('edit_image_link', 'required')" class="margin-bottom-5 validate-warning-msg">Link is required</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <div v-if="edit_item_type == 'Link'" class="col-12 override-padding">
          <input v-model="edit_item_link"
                name="edit_item_link"
                placeholder="Enter Link"
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'" 
                maxlength="255" />
          <div v-if="verrors.firstByRule('edit_item_link', 'required')" class="margin-bottom-5 validate-warning-msg">Link is required</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <input v-model="edit_item_link_text"
                name="edit_item_link_text"
                placeholder="Link Text"
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'"
                maxlength="255" />
          <div v-if="verrors.firstByRule('edit_item_link_text', 'required')" class="margin-bottom-5 validate-warning-msg">Text is required</div>
        </div>

        <div v-else-if="edit_item_type == 'Button'" class="col-12 override-padding">
          <input v-model="edit_item_button_text"
                name="edit_item_button_text"
                placeholder="Button Text"
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'"
                maxlength="255" />
          <div v-if="verrors.firstByRule('edit_item_button_text', 'required')" class="margin-bottom-5 validate-warning-msg">Button Text is required</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <input v-model="edit_item_button_link"
                name="edit_item_button_link"
                placeholder="Enter Link"
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'" 
                maxlength="255" />
          <div v-if="verrors.firstByRule('edit_item_button_link', 'required')" class="margin-bottom-5 validate-warning-msg">Link is required</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
        </div>

        <div style="clear: both;" class="margin-bottom-10"></div>
        <div v-if="edit_item_type == 'Assessment'" class="col-12 override-padding">
           <b-form-select
            class="input-text"
            name="edit_assessment_selected"
            v-model="edit_assessment_selected"
            :options="assessment_options" 
            v-validate="'required'"
            v-on:change="onEditChangeAssessmentType"
          >
          </b-form-select>
          <div v-if="verrors.firstByRule('edit_assessment_selected', 'required')" class="margin-bottom-5 validate-warning-msg">Assessment is required</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <div v-if="edit_item_type == 'Course'" class="col-12 override-padding">
           <b-form-select
            class="input-text"
            name="edit_course_selected"
            v-model="edit_course_selected"
            :options="course_options" 
            v-validate="'required'"
            v-on:change="onEditChangeCourseType"
          >
          </b-form-select>
          <div v-if="verrors.firstByRule('edit_course_selected', 'required')" class="margin-bottom-5 validate-warning-msg">Course is required</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div class="col-12 override-padding text-center">
          <button
              v-on:click="EditItem()"
              class="btn btn-red btn-md input-height-15 col-2"
              style="height: 30px;"
              ><b>Save</b></button>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </editItemModal>


    <editSlideModal :isModalVisible="isEditModalVisible" @close="isEditModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Edit Slide</h3></div>
      <div slot="body" v-if="isEditModalVisible == true">

        <div class="col-12 override-padding">
          <input v-model="edit_slide_title"
                name="edit_slide_title"
                placeholder="Enter Slide Title..."
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'"
                maxlength="255" />
         <div v-if="verrors.firstByRule('edit_slide_title', 'required')" class="margin-bottom-5 validate-warning-msg">Slide Title is required</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div class="col-12 override-padding">
             <b-form-select
              class="input-text"
              name="edit_slide_template"
              v-model="edit_slide_template"
              :options="template_options"
            >
            </b-form-select>
         <div v-if="verrors.firstByRule('edit_slide_template', 'required')" class="margin-bottom-5 validate-warning-msg">Slide Template is required</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <input
            type="checkbox"
            v-bind:id="edit_show_skip_button"
            v-bind:name="edit_show_skip_button"
            ref="edit_show_skip_button"
            v-model="edit_show_skip_button_selected"
            :checked="edit_show_skip_button_checked"
            :value="1" style="margin-top: 4px;">
          <label class="" for="submit_comment_1" style="color: #002F42;">Show Skip Button</label>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div class="col-12 override-padding text-center">
          <button
              v-on:click="EditSlide()"
              class="btn btn-red btn-md input-height-15 col-2"
              style="height: 30px;"
              ><b>Save</b></button>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </editSlideModal>



    <editIntroductionModal :isModalVisible="isEditIntroModalVisible" @close="isEditIntroModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Edit Introduction</h3></div>
      <div slot="body" v-if="isEditIntroModalVisible == true">

        <div class="col-12 override-padding">
          <input v-model="introduction_title"
                name="introduction_title"
                placeholder="Enter Title..."
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'"
                maxlength="255" />
         <div v-if="verrors.firstByRule('introduction_title', 'required')" class="margin-bottom-5 validate-warning-msg">Introduction Manager Title is required</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <multiselect
            v-model="affiliate_selected"
            :options="affiliate_options" track-by="name" label="name"
            placeholder="Select Affiliates..." :multiple="true"  :close-on-select="false" :show-labels="false"
            v-validate="'required'"
            name="affiliate"
            id="affiliate"
            >
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
          </multiselect>
          <div v-if="verrors.firstByRule('affiliate', 'required')" class="margin-bottom-5 validate-warning-msg">Affilates is required</div>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
  
        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <multiselect
            v-model="roles_selected"
            :options="roles_options"
            track-by="name" label="name"
            placeholder="Select Users..."
            :multiple="true" 
            :close-on-select="false"
            :show-labels="false"
            v-validate="'required'"
            name="roles"
            id="roles"
            >
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
      

          </multiselect>
          <div v-if="verrors.firstByRule('roles', 'required')" class="margin-bottom-5 validate-warning-msg">Users is required</div>

          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <input
            type="checkbox"
            v-bind:id="show_slide_number"
            v-bind:name="show_slide_number"
            ref="show_slide_number"
            v-model="show_slide_number_selected"
            :checked="show_slide_number_checked"
            :value="1" style="margin-top: 4px;">
          <label class="" for="submit_comment_1" style="color: #002F42;">Show Slide Numbers</label>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>


        <div class="col-12 override-padding text-align-right">
          <button
              v-on:click="editIntroduction()"
              class="btn btn-red btn-md input-height-15 col-2"
              style="height: 30px;"
              ><b>Save</b></button>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </editIntroductionModal>


    <viewItemModal :isModalVisible="isViewItemModalVisible" @close="isViewItemModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>View Introduction Item</h3></div>
      <div slot="body" v-if="isViewItemModalVisible == true">
        <div class="col-12 override-padding" v-if="this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].type == 'Image'">
          <div class="col-12 override-padding" >
            {{ this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].type }}
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding" >
            <img :src="this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].image" height="250" width="250" />
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding" >
            {{ this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].image_link }}
          </div>

          <div style="clear: both;" class="margin-bottom-10"></div>
        </div>

        <div class="col-12 override-padding" v-if="this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].type == 'Link'">
          <div class="col-12 override-padding" >
            {{ this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].type }}
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding" >
            {{ this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].text }}
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding" >
            {{ this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].image_link }}
          </div>

          <div style="clear: both;" class="margin-bottom-10"></div>
        </div>

        <div class="col-12 override-padding" v-if="this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].type == 'Button'">
          <div class="col-12 override-padding" >
            {{ this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].type }}
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding" >
            {{ this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].text }}
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding" >
            {{ this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].image_link }}
          </div>

          <div style="clear: both;" class="margin-bottom-10"></div>
        </div>

        <div class="col-12 override-padding" v-if="(this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].type == 'Assessment' || this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].type == 'Course')">
          <div class="col-12 override-padding" >
            {{ this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].type }}
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding" >
            {{ this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].text }}
          </div>

          <div style="clear: both;" class="margin-bottom-10"></div>
        </div>

        <div class="col-12 override-padding" v-if="this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].type == 'Text'">
          <div class="col-12 override-padding" >
            {{ this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].type }}
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding" v-html="this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].text">
          </div>

          <div style="clear: both;" class="margin-bottom-10"></div>
        </div>
        
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </viewItemModal>


  </div>
</template>


<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import VeeValidate from 'vee-validate';
import createSlideModal from '../admin/create-tasklist-modal.vue';
import editSlideModal from '../admin/create-tasklist-modal.vue';
import createItemModal from '../admin/create-tasklist-modal.vue';
import editItemModal from '../admin/create-tasklist-modal.vue';
import viewItemModal from '../admin/create-tasklist-modal.vue';
import editIntroductionModal from '../admin/create-tasklist-modal.vue';
import Multiselect from 'vue-multiselect';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import DeleteModal from '../shared/delete_modal_alert.vue';
import { VueEditor } from "vue2-editor";

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

Vue.filter('stripHTML', function (value) {
  let text = ''
    const parser = new DOMParser();
    const dom = parser.parseFromString(value, "text/html");
    let div = dom.querySelector('body>*');
    if(div){
      text = div.textContent || div.innerText || ''
    }
    return text
});

export default {
        data() {
          return {
            id: '',
            parent_id: '',
            masterAdmin: false,
            admin: false,
            slide_title: '',
            edit_slide_title: '',
            introduction_slide_obj: {
              introduction: [],
              slide: [],
              remove_slide: [],
              remove_item: [],
              slide_sort_flag: false,
            },
            loading: false,
            introduction_title: '',
            isModalVisible: false,
            isItemModalVisible: false,
            isDeleteModalVisible: false,
            selectedIndex: '',
            item_options: [
              { value: 'Text', text: 'Text' },
              { value: 'Image', text: 'Image' },
              { value: 'Link', text: 'Link' },
              { value: 'Button', text: 'Button' },
              { value: 'Assessment', text: 'Assessment' },
              { value: 'Course', text: 'Course' },
            ],
            item_type: 'Text',
            item_text: '',
            item_link: '',
            edit_item_link_text: '',
            item_link_text: '',
            edit_item_type: 'Text',
            edit_item_text: '',
            edit_item_link: '',
            item_button_text: '',
            item_button_link: '',
            edit_item_button_text: '',
            edit_item_button_link: '',
            base64Image: '',
            image: '',
            image_link: '',
            edit_image: '',
            edit_image_link: '',
            edit_image_file: '',
            assessment_options: [],
            course_options: [],
            assessment_selected: '',
            assessment_selectedText: '',
            edit_assessment_selected: '',
            edit_assessment_selectedText: '',
            course_selected: '',
            course_selectedText: '',
            edit_course_selected: '',
            edit_course_selectedText: '',
            deleteMessage: '',
            slideIndexValue: '',
            itemIndexValue: '',
            editItemIndexValue: '',
            editSlideIndexValue: '',
            deleteList: '',
            isEditItemModalVisible: false,
            isEditModalVisible: false,
            isEditIntroModalVisible: false,
            introduction_title: '',
            affiliate_options: [],
            roles_options: [
              {
                name: 'Admin',
                value: 'ROLE_ADMIN',
              },
              {
                name: 'Mentor',
                value: 'ROLE_MENTOR',
              },
              {
                name: 'Mentee',
                value: 'ROLE_MENTEE',
              },
              {
                name: 'Apprentice',
                value: 'ROLE_APPRENTICE',
              },
              {
                name: 'Instructor',
                value: 'ROLE_INSTRUCTOR',
              },
              {
                name: 'Student',
                value: 'ROLE_STUDENT',
              },
            ],
            affiliate_selected: [],
            roles_selected: [],
            show_slide_number_checked: 1,
            show_slide_number_selected: true,
            template_options: [
              {
                text: 'Horizontal',
                value: 1,
              },
              {
                text: 'Vertical',
                value: 2,
              },
            ],
            slide_template: 1,
            edit_slide_template: 1,
            show_skip_button_selected: true,
            show_skip_button_checked: 1,
            edit_show_skip_button_selected: true,
            edit_show_skip_button_checked: 1,
            customToolbar:[[{ list: "bullet" }, "bold", "italic", "underline", "link"]],
            isViewItemModalVisible: false,
          }
        },

        components: {
          UserMenu,
          GoBack,
          MasteradminSidebarMenu,
          createSlideModal,
          createItemModal,
          DeleteModal,
          editItemModal,
          editSlideModal,
          editIntroductionModal,
          Multiselect,
          VueEditor,
          viewItemModal,
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            introTextChange: function() {
              var limit = 1250;
              var quill = this.$refs.textarea.quill;

              quill.on('text-change', function (delta, old, source) {
               if (quill.getLength() > limit) {
                quill.deleteText(limit, quill.getLength());
               }
              });
            },
            RemoveImage() {
              this.edit_image_file = '';
              this.edit_image = '';
            },
            checkRemovedAffiliates: function() {
              var flag = 0;
            },
            editIntroduction: function() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {

                  axios('/check-removed-affiliate/' + this.introduction_id,
                     {
                       method: 'POST',
                       data:
                        {
                          affiliate_selected: this.affiliate_selected,
                        },
                     }
                   )
                  .then((resp) => {
                    var flag = resp.data.flag;
                    if(flag == 1) {
                      alert("Please select affiliates " + resp.data.affiliateNames + ". This affiliates are assigned to assessments or courses of an slides.")
                      return false;
                    }
                    else {
                      axios('/introduction-manager/' + this.introduction_id,
                         {
                           method: 'PATCH',
                           data:
                            {
                              introduction_title: this.introduction_title,
                              affiliate_selected: this.affiliate_selected,
                              roles_selected: this.roles_selected,
                              show_slide_numbers: this.show_slide_number_selected,
                            },
                         }
                       )
                      .then((resp) => {
                          this.introduction_title = '';
                          this.affiliate_selected = [];
                          this.roles_selected = [];
                          this.isEditIntroModalVisible = false;
                          this.fetchSlideLists();
                          setTimeout(() => {
                            this.fetchAssessmentOptions();
                            this.fetchCourseOptions();
                          }, 1000);
                       })
                      .catch(error => {
                        if(error.response.data.code == '404') {
                          router.push("/view-tasklist");
                        }
                      });
                    }
                   })
                  .catch(error => {
                    
                  });
                }
              });
            },
            editIntroductionModalAction: function() {
              this.introduction_title = this.introduction_slide_obj.introduction.name;
              this.affiliate_selected = this.introduction_slide_obj.introduction.affiliate_assigned;
              this.roles_selected = this.introduction_slide_obj.introduction.roles_assigned;
              this.show_slide_number_selected = this.introduction_slide_obj.introduction.show_slide_numbers;
              this.show_slide_number_checked = this.introduction_slide_obj.introduction.show_slide_numbers;
              this.isEditIntroModalVisible = true;
            },
            EditSlide() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                  var edit_data = this.introduction_slide_obj.slide[this.editSlideIndexValue];
                  this.introduction_slide_obj.slide[this.editSlideIndexValue].title = this.edit_slide_title;
                  this.introduction_slide_obj.slide[this.editSlideIndexValue].template = this.edit_slide_template;
                  this.introduction_slide_obj.slide[this.editSlideIndexValue].showSkipButton = this.edit_show_skip_button_selected;
                  if(this.introduction_slide_obj.slide[this.editSlideIndexValue].update == true) {
                    this.introduction_slide_obj.slide[this.editSlideIndexValue].modified = true;
                  }
                  this.isEditModalVisible = false;
                  this.$store.dispatch('introduction_template', this.introduction_slide_obj);
                }
              });
            },
            editSlideAction: function(slideIndex) {
              this.editSlideIndexValue = slideIndex;
              var edit_data = this.introduction_slide_obj.slide[this.editSlideIndexValue];
              this.edit_slide_title = edit_data.title;
              this.edit_slide_template = edit_data.template;
              this.edit_show_skip_button_selected = edit_data.showSkipButton;
              this.edit_show_skip_button_checked = edit_data.showSkipButton;
              this.isEditModalVisible = true;
            },

            doEditValidate: function() {
              var vflag = 1;
              if(this.edit_item_type == 'Text') {
                if(this.edit_item_text == '') {
                  alert("Please enter Text");
                  vflag = 0;
                  return false;
                }
              }
              else if(this.edit_item_type == 'Image') {
                if(this.edit_image == '') {
                  alert("Please upload Image");
                  vflag = 0;
                  return false;
                }
                else {
                  if(this.edit_image_file == '') {
                  if((this.$refs.edit_image_file.files[0].type != 'image/jpeg') && (this.$refs.edit_image_file.files[0].type != 'image/jpg') && (this.$refs.edit_image_file.files[0].type != 'image/png') && (this.$refs.edit_image_file.files[0].type != 'image/gif')) {
                    alert("Image should be of jpeg, jpg, png, gif formats only");
                    vflag = 0;
                    return false;
                  }
                  else if(this.$refs.edit_image_file.files[0].size > 2000000) {
                    alert("Image size should be of 2 MB only");
                    vflag = 0;
                    return false;
                  }
                  }
                }
                if(this.edit_image_link == '') {
                  alert("Please enter Link");
                  vflag = 0;
                  return false;
                }
              }
              else if(this.edit_item_type == 'Link') {
                if(this.edit_item_link == '') {
                  alert("Please enter Link");
                  vflag = 0;
                  return false;
                }
                if(this.edit_item_link_text == '') {
                  alert("Please enter Text");
                  vflag = 0;
                  return false;
                }
              }
              else if(this.edit_item_type == 'Button') {
                if(this.edit_item_button_text == '') {
                  alert("Please enter Button Text");
                  vflag = 0;
                  return false;
                }
                if(this.edit_item_button_link == '') {
                  alert("Please enter Link");
                  vflag = 0;
                  return false;
                }
              }
              else if(this.edit_item_type == 'Assessment') {
                if(this.edit_assessment_selected == '') {
                  alert("Please select Assessment");
                  vflag = 0;
                  return false;
                }
              }
              else if(this.edit_item_type == 'Course') {
                if(this.edit_course_selected == '') {
                  alert("Please select Course");
                  vflag = 0;
                  return false;
                }
              }
              return vflag;
            },

            EditItem() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                  var vflag = this.doEditValidate();
                  if(vflag == 1) {
                  var edit_data = this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue];
                  if(this.edit_item_type == 'Text') {
                    this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].text = this.edit_item_text;
                    if(this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].update == true) {
                      this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].modified = true;
                    }
                  }
                  else if(this.edit_item_type == 'Image') {
                    this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].image = this.edit_image;
                    this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].image_link = this.edit_image_link;
                    if(this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].update == true) {
                      this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].modified = true;
                    }
                  }
                  else if(this.edit_item_type == 'Link') {
                    this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].text = this.edit_item_link_text;
                    this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].image_link = this.edit_item_link;
                    if(this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].update == true) {
                      this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].modified = true;
                    }
                  }
                  else if(this.edit_item_type == 'Button') {
                    this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].text = this.edit_item_button_text;
                    this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].image_link = this.edit_item_button_link;
                    if(this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].update == true) {
                      this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].modified = true;
                    }
                  }
                  else if(this.edit_item_type == 'Assessment') {
                    this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].text = this.edit_assessment_selectedText;
                    this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].assessmentId = this.edit_assessment_selected;
                    if(this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].update == true) {
                      this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].modified = true;
                    }
                  }
                  else if(this.edit_item_type == 'Course') {
                    this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].text = this.edit_course_selectedText;
                    this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].courseId = this.edit_course_selected;
                    if(this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].update == true) {
                      this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue].modified = true;
                    }
                  }
                  this.edit_item_type = 'Text';
                  this.isEditItemModalVisible = false;
                  this.editSlideIndexValue = '';
                  this.editItemIndexValue = '';
                  this.$store.dispatch('introduction_template', this.introduction_slide_obj);
                  }
                }
              });
            },
            viewAction: function(slideIndex, itemIndex) {
              this.editSlideIndexValue = slideIndex;
              this.editItemIndexValue = itemIndex;
              this.isViewItemModalVisible = true;
            },
            editAction: function(slideIndex, itemIndex) {
              this.editSlideIndexValue = slideIndex;
              this.editItemIndexValue = itemIndex;
              var edit_data = this.introduction_slide_obj.slide[this.editSlideIndexValue].item[this.editItemIndexValue];
              if(edit_data.type == 'Text') {
                this.edit_item_type = edit_data.type;
                this.edit_item_text = edit_data.text;
              }
              else if(edit_data.type == 'Image') {
                this.edit_item_type = edit_data.type;
                this.edit_image_file = edit_data.image;
                this.edit_image = edit_data.image;
                this.edit_image_link = edit_data.image_link;
              }
              else if(edit_data.type == 'Link') {
                this.edit_item_type = edit_data.type;
                this.edit_item_link_text = edit_data.text;
                this.edit_item_link = edit_data.image_link;
              }
              else if(edit_data.type == 'Button') {
                this.edit_item_type = edit_data.type;
                this.edit_item_button_text = edit_data.text;
                this.edit_item_button_link = edit_data.image_link;
              }
              else if(edit_data.type == 'Assessment') {
                this.edit_item_type = edit_data.type;
                this.edit_assessment_selected = edit_data.assessmentId;
              }
              else if(edit_data.type == 'Course') {
                this.edit_item_type = edit_data.type;
                this.edit_course_selected = edit_data.courseId;
              }
              this.isEditItemModalVisible = true;
            },
            deleteAction: function() {
              if(this.deleteList == 'Slide') {
                var remove_data = this.introduction_slide_obj.slide[this.slideIndexValue];
                if(remove_data.update == true) {
                  this.introduction_slide_obj.remove_slide.push({
                    slide_id: remove_data.id,
                  });
                  this.introduction_slide_obj.slide.splice(this.slideIndexValue, 1);
                }
                else {
                  this.introduction_slide_obj.slide.splice(this.slideIndexValue, 1);
                }
                setTimeout(() => {
                  var j=1;
                  for(var i=0; i < this.introduction_slide_obj.slide.length; i++) {
                    this.introduction_slide_obj.slide[i].sortid = 'slide-' + j;
                    var y=1;
                    for(var x=0; x < this.introduction_slide_obj.slide[i].item.length; x++) {
                      this.introduction_slide_obj.slide[i].item[x].sortid = 'slide-' + j + '-item-' + y;
                      y++;
                    }
                    j++;
                  }
                  this.$store.dispatch('introduction_template', this.introduction_slide_obj);
                }, 1000);
                this.$store.dispatch('introduction_template', this.introduction_slide_obj);
              }
              else if(this.deleteList == 'Item') {
                var remove_data = this.introduction_slide_obj.slide[this.slideIndexValue].item[this.itemIndexValue];
                if(remove_data.update == true) {
                  this.introduction_slide_obj.remove_item.push({
                     item_id : remove_data.id,
                  });
                  this.introduction_slide_obj.slide[this.slideIndexValue].item.splice(this.itemIndexValue, 1);
                }
                else {
                  this.introduction_slide_obj.slide[this.slideIndexValue].item.splice(this.itemIndexValue, 1);
                }
                setTimeout(() => {
                  var parent_sortid = this.introduction_slide_obj.slide[this.slideIndexValue].sortid;
                  var j=1;
                  for(var i=0; i < this.introduction_slide_obj.slide[this.slideIndexValue].item.length; i++) {
                    this.introduction_slide_obj.slide[this.slideIndexValue].item[i].sortid = parent_sortid + '-item-' + j;
                    j++;
                  }
                  this.$store.dispatch('introduction_template', this.introduction_slide_obj);
                }, 1000);

                this.$store.dispatch('introduction_template', this.introduction_slide_obj);
              }
            },
            deleteSlideConfirm: function(slideIndex) {
              this.deleteMessage = 'Are you sure you want to delete? This will delete the slide and related items.';
              this.slideIndexValue = slideIndex;
              this.deleteList = 'Slide';
              this.isDeleteModalVisible = true;
            },
            deleteItemConfirm: function(slideIndex, itemIndex) {
              this.deleteMessage = 'Are you sure you want to delete? This will delete the item.';
              this.slideIndexValue = slideIndex;
              this.itemIndexValue = itemIndex;
              this.deleteList = 'Item';
              this.isDeleteModalVisible = true;
            },

            handleImage(e) {
              var selectedImage = e.target.files[0];
              this.createBase64Image(selectedImage);
            },
            handleEditImage(e) {
              var selectedImage = e.target.files[0];
              this.createEditBase64Image(selectedImage);
            },
            onSubmit () {
              axios('/introduction-slide-mapping-lists/' + this.introduction_id,
              {
                 method: 'POST',
                 data: {
                    "introduction_slide_obj": this.introduction_slide_obj,
                  }
              })
              .then((resp) => {
                this.$store.dispatch('introduction_template', '');
                router.push("/introduction-manager-list");

               })
              .catch(error => {

              });
            },
            createBase64Image(fileObject){
              const reader = new FileReader();
              reader.onload = (e) => {
                this.image = e.target.result;
              };
              reader.readAsDataURL(fileObject);
            },
            createEditBase64Image(fileObject){
              const reader = new FileReader();
              reader.onload = (e) => {
                this.edit_image = e.target.result;
              };
              reader.readAsDataURL(fileObject);
            },

            onEditChangeAssessmentType: function(e) {
              var val = e;
              for (var i = 0; i < this.assessment_options.length; i++) {
                if (this.assessment_options[i].value === val){
                  this.edit_assessment_selectedText = this.assessment_options[i].text;
                }
              }
            },
            onChangeAssessmentType: function(e) {
              var val = e;
              for (var i = 0; i < this.assessment_options.length; i++) {
                if (this.assessment_options[i].value === val){
                  this.assessment_selectedText = this.assessment_options[i].text;
                }
              }
            },
            onEditChangeCourseType: function(e) {
              var val = e;
              for (var i = 0; i < this.course_options.length; i++) {
                if (this.course_options[i].value === val){
                  this.edit_course_selectedText = this.course_options[i].text;
                }
              }
            },
            onChangeCourseType: function(e) {
              var val = e;
              for (var i = 0; i < this.course_options.length; i++) {
                if (this.course_options[i].value === val){
                  this.course_selectedText = this.course_options[i].text;
                }
              }
            },
            addSlideClick: function() {
              this.isModalVisible = true;
              this.verrors.clear();
            },
            addItemClick: function(index) {
              this.selectedIndex = index;
              if(this.introduction_slide_obj.slide[this.selectedIndex].item.length >= 5) {
                alert("You can add maximum 5 items for slide");
                return false;
              }
              else {
                this.item_type = 'Text';
                this.isItemModalVisible = true;
                this.verrors.clear();
              }
            },
            reorderSection ({oldIndex, newIndex}) {
              this.introduction_slide_obj.slide_sort_flag = true;
              const movedItem = this.introduction_slide_obj.slide.splice(oldIndex, 1)[0];
              this.introduction_slide_obj.slide.splice(newIndex, 0, movedItem);
              this.$store.dispatch('introduction_template', this.introduction_slide_obj);
            },
            doValidate: function() {
              var vflag = 1;
              if(this.item_type == 'Text') {
                if(this.item_text == '') {
                  alert("Please enter Text");
                  vflag = 0;
                  return false;
                }
              }
              else if(this.item_type == 'Image') {
                if(this.image == '') {
                  alert("Please upload Image");
                  vflag = 0;
                  return false;
                }
                else if(this.$refs.image_file.files[0].size > 2000000) {
                    alert("Image size should be of 2 MB only");
                    vflag = 0;
                    return false;
                }
                else {
                  if((this.$refs.image_file.files[0].type != 'image/jpeg') && (this.$refs.image_file.files[0].type != 'image/jpg') && (this.$refs.image_file.files[0].type != 'image/png') && (this.$refs.image_file.files[0].type != 'image/gif')) {
                    alert("Image should be of jpeg, jpg, png, gif formats only");
                    vflag = 0;
                    return false;
                    }
                }
                if(this.image_link == '') {
                  alert("Please enter Link");
                  vflag = 0;
                  return false;
                }
              }
              else if(this.item_type == 'Link') {
                if(this.item_link == '') {
                  alert("Please enter Link");
                  vflag = 0;
                  return false;
                }
                if(this.item_link_text == '') {
                  alert("Please enter Text");
                  vflag = 0;
                  return false;
                }
              }
              else if(this.item_type == 'Button') {
                if(this.item_button_text == '') {
                  alert("Please enter Button Text");
                  vflag = 0;
                  return false;
                }
                if(this.item_button_link == '') {
                  alert("Please enter Link");
                  vflag = 0;
                  return false;
                }
              }
              else if(this.item_type == 'Assessment') {
                if(this.assessment_selected == '') {
                  alert("Please select Assessment");
                  vflag = 0;
                  return false;
                }
              }
              else if(this.item_type == 'Course') {
                if(this.course_selected == '') {
                  alert("Please select Course");
                  vflag = 0;
                  return false;
                }
              }
              return vflag;
            },
            AddItem() {
              
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                var vflag = this.doValidate();
                if(vflag == 1) {
                  var sort_id = this.introduction_slide_obj.slide[this.selectedIndex].sortid;
                  var item_len = this.introduction_slide_obj.slide[this.selectedIndex].item.length + 1;
                  if(this.item_type == 'Text') {
                    this.introduction_slide_obj.slide[this.selectedIndex].item.push({
                      id: '',
                      type: this.item_type,
                      text: this.item_text,
                      edit: false,
                      update: false,
                      modified: false,
                      sortid: sort_id + '-item-' + item_len,
                    });
                    this.item_text = '';
                  }
                  else if(this.item_type == 'Image') {
                    this.introduction_slide_obj.slide[this.selectedIndex].item.push({
                      id: '',
                      type: this.item_type,
                      image: this.image,
                      image_link: this.image_link,
                      edit: false,
                      update: false,
                      modified: false,
                      sortid: sort_id + '-item-' + item_len,
                    });
                    this.image = '';
                    this.image_link = '';
                  }
                  else if(this.item_type == 'Link') {
                    this.introduction_slide_obj.slide[this.selectedIndex].item.push({
                      id: '',
                      type: this.item_type,
                      text: this.item_link_text,
                      image_link: this.item_link,
                      edit: false,
                      update: false,
                      modified: false,
                      sortid: sort_id + '-item-' + item_len,
                    });
                    this.item_link = '';
                    this.item_link_text = '';
                  }
                  else if(this.item_type == 'Button') {
                    this.introduction_slide_obj.slide[this.selectedIndex].item.push({
                      id: '',
                      type: this.item_type,
                      text: this.item_button_text,
                      image_link: this.item_button_link,
                      edit: false,
                      update: false,
                      modified: false,
                      sortid: sort_id + '-item-' + item_len,
                    });
                    this.item_button_link = '';
                    this.item_button_text = '';
                  }
                  else if(this.item_type == 'Assessment') {
                    this.introduction_slide_obj.slide[this.selectedIndex].item.push({
                      id: '',
                      type: this.item_type,
                      text: this.assessment_selectedText,
                      assessmentId: this.assessment_selected,
                      edit: false,
                      update: false,
                      modified: false,
                      sortid: sort_id + '-item-' + item_len,
                    });
                    this.assessment_selectedText = '';
                    this.assessment_selected = '';
                  }
                  else if(this.item_type == 'Course') {
                    this.introduction_slide_obj.slide[this.selectedIndex].item.push({
                      id: '',
                      type: this.item_type,
                      text: this.course_selectedText,
                      courseId: this.course_selected,
                      edit: false,
                      update: false,
                      modified: false,
                      sortid: sort_id + '-item-' + item_len,
                    });
                    this.assessment_selectedText = '';
                    this.assessment_selected = '';
                  }
                  this.item_type = 'Text';
                  this.isItemModalVisible = false;
                  this.$store.dispatch('introduction_template', this.introduction_slide_obj);
                }
                }
              });

            },
            createSlide() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                  var slide_len = this.introduction_slide_obj.slide.length + 1;
                  this.introduction_slide_obj.slide.push({
                    id: '',
                    title: this.slide_title,
                    template: this.slide_template,
                    showSkipButton: this.show_skip_button_selected,
                    item: [],
                    edit: false,
                    update: false,
                    modified: false,
                    sortid: 'slide-' + slide_len,
                  });
                  this.isModalVisible = false;
                  this.slide_title = '';
                  this.slide_template = 1;
                  this.$store.dispatch('introduction_template', this.introduction_slide_obj);
                }
              });

            },
            fetchSlideLists: function() {
              this.loading = true;
              axios.get('/introduction-slide-mapping-lists/' + this.introduction_id)
                .then((resp) => {
                  this.loading = false;
                  this.introduction_slide_obj.introduction = resp.data.introduction;
                  this.introduction_slide_obj.slide = resp.data.slide;
                  this.introduction_title = resp.data.introduction.name;
                  this.$store.dispatch('introduction_template', this.introduction_slide_obj);
              })
              .catch(error => {

              });

            },
            fetchAssessmentOptions: function(){
              axios('/introduction-slide/get-assessments', {
                 method: 'POST',
                 data:
                  {
                    affiliate_selected: this.introduction_slide_obj.introduction.affiliate_assigned,
                  },
              })
                .then((response) => {
                   var assessment_option = {value: '', text: 'Select Assessment'};
                   this.assessment_options.push(assessment_option);
                   for(var i=0; i < response.data.length; i++) {
                     var assessment_option = {value: response.data[i].id, text: response.data[i].title};
                     this.assessment_options.push(assessment_option);
                   }

              })
              .catch(error => {

              });

            },
            fetchCourseOptions: function(){

              axios('/introduction-slide/get-courses', {
                 method: 'POST',
                 data:
                  {
                    affiliate_selected: this.introduction_slide_obj.introduction.affiliate_assigned,
                  },
              })
                .then((response) => {
                   var course_option = {value: '', text: 'Select Course'};
                   this.course_options.push(course_option);
                   for(var i=0; i < response.data.length; i++) {
                     var course_option = {value: response.data[i].lms_course_id, text: response.data[i].lms_course_title};
                     this.course_options.push(course_option);
                   }

              })
              .catch(error => {

              });

            },
            fetchAffiliateOptions: function() {
             axios.get('/affiliateoptions', {

             })
             .then((response) => {
                 var affiliate_option = {value: '', name: 'Select Affiliate'};
                 this.affiliate_options.push(affiliate_option);
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, name: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
             })
             .catch(error => {

             });

            },

        },
        created() {
           this.introduction_id = this.$route.params.introduction_id;
           var roles = store.state.roles;
           if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
             this.masterAdmin = true;
           }
           if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
             this.admin = true;
           }
           if((!this.$store.state.introduction_template.introduction) && (!this.$store.state.introduction_template.slide)) {
            this.fetchSlideLists();
           }
           else {
            this.loading = false;
            this.introduction_slide_obj = this.$store.state.introduction_template;
            this.introduction_title = this.introduction_slide_obj.introduction.name;

           }
           setTimeout(() => {
            this.fetchAssessmentOptions();
            this.fetchCourseOptions();
           }, 1000);
           this.fetchAffiliateOptions();

        }

}
</script>

<style scoped>
.task-list-summary {
  font-size: 18px;
  font-weight: bold;
  padding-top: 5px;
}
.help-text {
  font-size: 12px;
  font-style: italic;
}
</style>
<style>
#mentee-tasklist-wrapper li span.multiselect__option--selected span::before,
#mentee-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected.multiselect__option--highlight,
#mentee-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: #fff !important;
}
.modal-header h3 {
  color: #002F42;
  font-size: 16px;
  font-weight: bold;
}
.modal-header .sub-heading {
  margin-left: 5px;
}
.assessment-intro1  .ql-editor { height: 140px !important; min-height: 155px !important; overflow-y: scroll !important; }
.assessment-intro1 .quillWrapper .ql-container.ql-snow {
  border: 1px solid #ccc !important;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/introduction_add_slides.vue